import { type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { button } from './button-variants';
import { cn } from '@/lib/utils';

/**
 * Variants via `cva`, never boolean prop soup: `<Button small outlined danger />` makes 2³
 * combinations representable and most of them meaningless. They live in `button-variants.ts` so an
 * anchor can wear them too — see that file.
 */

type Props = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof button> & {
    /** Shows a progress state and disables the button. Distinct from `disabled`. */
    isBusy?: boolean;
    children?: ReactNode;
  };

export function Button({ className, variant, size, isBusy, disabled, children, ...rest }: Props) {
  return (
    <button
      type="button"
      className={cn(button({ variant, size }), className)}
      disabled={disabled === true || isBusy === true}
      // Announced to a screen reader, which a spinner alone is not.
      aria-busy={isBusy === true}
      {...rest}
    >
      {children}
    </button>
  );
}
